// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3YxJe","select":"Header_select__2wtlZ","clinic":"Header_clinic__3XjgU"};